import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Layout as ProfileLayOut } from 'src/layouts/setting';
import { PublicLayout } from 'src/layouts/setting/public-layout';

const MyOrderPage = lazy(() => import('src/pages/profile/myOrder'));
const MyProfilePage = lazy(() => import('src/pages/profile/myProfile'));

export const profileRoute = [
    {
        path: 'profile',
        element: (
            <ProfileLayOut>
                <Suspense fallback={<div>Loading...</div>}>
                    <Outlet />
                </Suspense>
            </ProfileLayOut>
        ),
        children: [
            // PROFILE PAGES
            { path: 'myOrder', element: <MyOrderPage /> },
            { path: 'myProfile', element: <MyProfilePage /> },
        ]
    }
];
